import { loadFeatureUpvotes } from "../Features";
import { loadCourseCreation } from "./createCourse";
import { loadGoToAbListener } from "./loadAb";
import { loadSendFeedbackFunctionality } from "./sendFeedback";


export function loadHome(){
    // loadGoToAbListener()
    loadSendFeedbackFunctionality()
    loadFeatureUpvotes()
    loadCourseCreation()
}